// File: InvoicePrint.jsx
import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import axios from "../../axios";
import printLayoutApi from "../../api/printLayoutApi";
import html2pdf from "html2pdf.js";
import InvoiceTemplate from "../../components/InvoiceTemplate";

export default function InvoicePrint() {
  const { id } = useParams();
  const [data, setData] = useState(null);

  const [layout, setLayout] = useState(null);
  const [loading, setLoading] = useState(true);

  const [searchParams] = useSearchParams();
  const autoPrint = searchParams.get("auto") === "true";

  useEffect(() => {
    if (!id) return;
    
    const fetchData = async () => {
      try {
        const invRes = await axios.get(`/Invoice/print/${id}`);
        const invoiceData = invRes.data;
        setData(invoiceData);

        // Fetch layout if invoice type is available
        if (invoiceData.invoiceTypeId || invoiceData.invoiceType) {
          const typeId = invoiceData.invoiceTypeId || invoiceData.invoiceType;
          const companyId = parseInt(localStorage.getItem("companyId"), 10);
          try {
            const layoutRes = await printLayoutApi.get(companyId, typeId);
            if (layoutRes.data && layoutRes.data.layoutJson) {
              const parsedLayout = JSON.parse(layoutRes.data.layoutJson);
              setLayout(parsedLayout);
            }
          } catch (err) {
            console.log("No custom layout found, using default.");
          }
        }
      } catch (err) {
        console.error("🛑 خطأ في تحميل الفاتورة:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  // الطباعة التلقائية عند اكتمال التحميل
  useEffect(() => {
    if (!loading && data && autoPrint) {
      setTimeout(() => {
        handlePrint();
      }, 500); // تأخير بسيط لضمان اكتمال الريندر
    }
  }, [loading, data, autoPrint]);

  if (loading) return <div>⏳ جاري تحميل الفاتورة...</div>;
  if (!data) return <div>❌ تعذر تحميل بيانات الفاتورة</div>;

  const handlePrint = () => window.print();

  const handleExportPDF = () => {
    const element = document.getElementById("invoice-template-container");
    html2pdf()
      .set({
        margin: 10,
        filename: `فاتورة_${data.invoiceNumber}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      })
      .from(element)
      .save();
  };

  return (
    <div style={{ padding: "10px", fontFamily: "Tajawal, sans-serif" }}>
      {/* 🔘 أزرار التحكم */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "10px",
          marginBottom: "10px",
        }}
        className="print-hidden"
      >
        <button onClick={handlePrint}>🖨️ طباعة</button>
        <button onClick={handleExportPDF}>📄 حفظ PDF</button>
      </div>

      <style>
        {`
          @media print {
            @page {
              margin: 0;
              size: auto;
            }
            body {
              margin: 0;
              padding: 0;
            }
            .print-hidden {
              display: none !important;
            }
            #invoice-template-container {
              box-shadow: none !important;
              margin: 0 !important;
              width: 100% !important;
              height: 100% !important;
              border: none !important;
            }
          }
        `}
      </style>

      {/* 🔖 Invoice Content */}
      <InvoiceTemplate data={data} layout={layout} />
    </div>
  );
}
